// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BulkAssignView-module__viewHeader___JHKmz {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.BulkAssignView-module__viewHeaderIcon___C2IVK {
  width: 16px;
  height: 16px;
  color: #71717a;
  flex-shrink: 0;
}

.BulkAssignView-module__viewHeaderTitle___WGlUf {
  font-size: 14px;
  font-weight: 600;
  color: #18181b;
}

.BulkAssignView-module__viewHeaderDescription___d1fV6 {
  font-size: 13px;
  color: #a1a1aa;
}

.BulkAssignView-module__countsRow___gaeJH {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BulkAssignView-module__selectAllCheckbox___lIKgy {
  width: 14px;
  height: 14px;
  cursor: pointer;
  flex-shrink: 0;
  accent-color: #18181b;
  margin: 0;
}

.BulkAssignView-module__selectAllCheckbox___lIKgy:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.BulkAssignView-module__sectionCheckbox___JDyRn {
  width: 14px;
  height: 14px;
  cursor: pointer;
  flex-shrink: 0;
  accent-color: #18181b;
  margin: 0;
}

/* Floating action bar */
.BulkAssignView-module__floatingBar____v7Ec {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 40;
  animation: BulkAssignView-module__slideUp___rH06P 0.2s ease-out;
}

@keyframes BulkAssignView-module__slideUp___rH06P {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}
.BulkAssignView-module__floatingBarInner___LSXY_ {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.06);
  padding: 8px 16px;
  white-space: nowrap;
}

.BulkAssignView-module__floatingBarLabel___sxEkG {
  font-size: 13px;
  font-weight: 500;
  color: #3f3f46;
}

.BulkAssignView-module__floatingBarPrimary___xME3t {
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  background: #18181b;
  border: none;
  border-radius: 6px;
  padding: 5px 12px;
  cursor: pointer;
  line-height: 1.4;
}

.BulkAssignView-module__floatingBarPrimary___xME3t:hover {
  background: #27272a;
}

.BulkAssignView-module__floatingBarGhost___oRMRA {
  font-size: 13px;
  font-weight: 400;
  color: #71717a;
  background: transparent;
  border: none;
  border-radius: 6px;
  padding: 5px 8px;
  cursor: pointer;
  line-height: 1.4;
}

.BulkAssignView-module__floatingBarGhost___oRMRA:hover {
  color: #18181b;
  background: #f4f4f5;
}

/* Selected task breakdown row */
.BulkAssignView-module__selectedBreakdownRow___DdknO {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  margin-top: 4px;
}

.BulkAssignView-module__selectedBreakdownLabel___rSoWI {
  font-size: 11px;
  color: #71717a;
  line-height: 1.2;
  white-space: nowrap;
}

.BulkAssignView-module__selectedBreakdownItem___Gi5pG {
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
  color: #71717a;
}

.BulkAssignView-module__selectedBreakdownDivider___uRKnX {
  font-size: 11px;
  line-height: 1.2;
  color: #a1a1aa;
}

.BulkAssignView-module__selectedBreakdownCritical___b17ve {
  color: #b91c1c;
  font-weight: 600;
}

.BulkAssignView-module__selectedBreakdownHigh___IN2I2 {
  color: #c2410c;
}

.BulkAssignView-module__selectedBreakdownMedium___MgGvH {
  color: #ca8a04;
}

.BulkAssignView-module__selectedBreakdownLow___rN7RG {
  color: #71717a;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/BulkAssignView/BulkAssignView.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,SAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,SAAA;AACF;;AAEA,wBAAA;AACA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,+DAAA;AACF;;AAEA;EACE;IACE,UAAA;IACA,4CAAA;EACF;EACA;IACE,UAAA;IACA,yCAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yEAAA;EACA,iBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,mBAAA;AAAF;;AAGA,gCAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,cAAA;AAAF","sourcesContent":[".viewHeader {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.viewHeaderIcon {\n  width: 16px;\n  height: 16px;\n  color: #71717a;\n  flex-shrink: 0;\n}\n\n.viewHeaderTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.viewHeaderDescription {\n  font-size: 13px;\n  color: #a1a1aa;\n}\n\n.countsRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.selectAllCheckbox {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n  flex-shrink: 0;\n  accent-color: #18181b;\n  margin: 0;\n}\n\n.selectAllCheckbox:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n\n.sectionCheckbox {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n  flex-shrink: 0;\n  accent-color: #18181b;\n  margin: 0;\n}\n\n/* Floating action bar */\n.floatingBar {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 40;\n  animation: slideUp 0.2s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n.floatingBarInner {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #fff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.06);\n  padding: 8px 16px;\n  white-space: nowrap;\n}\n\n.floatingBarLabel {\n  font-size: 13px;\n  font-weight: 500;\n  color: #3f3f46;\n}\n\n.floatingBarPrimary {\n  font-size: 13px;\n  font-weight: 500;\n  color: #fff;\n  background: #18181b;\n  border: none;\n  border-radius: 6px;\n  padding: 5px 12px;\n  cursor: pointer;\n  line-height: 1.4;\n}\n\n.floatingBarPrimary:hover {\n  background: #27272a;\n}\n\n.floatingBarGhost {\n  font-size: 13px;\n  font-weight: 400;\n  color: #71717a;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  padding: 5px 8px;\n  cursor: pointer;\n  line-height: 1.4;\n}\n\n.floatingBarGhost:hover {\n  color: #18181b;\n  background: #f4f4f5;\n}\n\n/* Selected task breakdown row */\n.selectedBreakdownRow {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n  margin-top: 4px;\n}\n\n.selectedBreakdownLabel {\n  font-size: 11px;\n  color: #71717a;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.selectedBreakdownItem {\n  font-size: 11px;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: #71717a;\n}\n\n.selectedBreakdownDivider {\n  font-size: 11px;\n  line-height: 1.2;\n  color: #a1a1aa;\n}\n\n.selectedBreakdownCritical {\n  color: #b91c1c;\n  font-weight: 600;\n}\n\n.selectedBreakdownHigh {\n  color: #c2410c;\n}\n\n.selectedBreakdownMedium {\n  color: #ca8a04;\n}\n\n.selectedBreakdownLow {\n  color: #71717a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewHeader": `BulkAssignView-module__viewHeader___JHKmz`,
	"viewHeaderIcon": `BulkAssignView-module__viewHeaderIcon___C2IVK`,
	"viewHeaderTitle": `BulkAssignView-module__viewHeaderTitle___WGlUf`,
	"viewHeaderDescription": `BulkAssignView-module__viewHeaderDescription___d1fV6`,
	"countsRow": `BulkAssignView-module__countsRow___gaeJH`,
	"selectAllCheckbox": `BulkAssignView-module__selectAllCheckbox___lIKgy`,
	"sectionCheckbox": `BulkAssignView-module__sectionCheckbox___JDyRn`,
	"floatingBar": `BulkAssignView-module__floatingBar____v7Ec`,
	"slideUp": `BulkAssignView-module__slideUp___rH06P`,
	"floatingBarInner": `BulkAssignView-module__floatingBarInner___LSXY_`,
	"floatingBarLabel": `BulkAssignView-module__floatingBarLabel___sxEkG`,
	"floatingBarPrimary": `BulkAssignView-module__floatingBarPrimary___xME3t`,
	"floatingBarGhost": `BulkAssignView-module__floatingBarGhost___oRMRA`,
	"selectedBreakdownRow": `BulkAssignView-module__selectedBreakdownRow___DdknO`,
	"selectedBreakdownLabel": `BulkAssignView-module__selectedBreakdownLabel___rSoWI`,
	"selectedBreakdownItem": `BulkAssignView-module__selectedBreakdownItem___Gi5pG`,
	"selectedBreakdownDivider": `BulkAssignView-module__selectedBreakdownDivider___uRKnX`,
	"selectedBreakdownCritical": `BulkAssignView-module__selectedBreakdownCritical___b17ve`,
	"selectedBreakdownHigh": `BulkAssignView-module__selectedBreakdownHigh___IN2I2`,
	"selectedBreakdownMedium": `BulkAssignView-module__selectedBreakdownMedium___MgGvH`,
	"selectedBreakdownLow": `BulkAssignView-module__selectedBreakdownLow___rN7RG`
};
module.exports = ___CSS_LOADER_EXPORT___;
